module.exports = __webpack_public_path__ + "img/二次曝光的智能医疗医生以经营研发工作.07930263.jpg";